<template>
  <v-app class="relative h-100 gradient-bg">
    <main-layout>
      <div class="d-flex align-center justify-center  items-center h-100">
        <v-container class="text-center">
          <h1 class="ibm-plex-sans-thai-light mb-2" style="font-size: 3em;">
            {{ $t('title')}}
          </h1>
          <h4 class="ibm-plex-sans-thai-light mb-6">
            {{ $t('subtitle') }} 
          </h4>
          <div class="d-flex justify-center">
            <div style="width: 100%; max-width: 900px;">
              <search-bar />
            </div>
          </div>
        </v-container>
      </div>
    </main-layout>
  </v-app>
</template>

<script>
import SearchBar from '../components/SearchBar.vue'
import mainLayout from '../layouts/mainLayout.vue'

export default {
  name: 'MainView',
  components: {
    SearchBar,
    mainLayout
  }
}
</script>

<style scoped>
.gradient-bg {
  background: #dfe5f5;
  background: radial-gradient(circle, rgba(223, 229, 245, 1) 0%, rgba(242, 242, 247, 1) 38%);
}
</style>